import addons from "./addons";
import airQuality from "./airQuality";
import alerts from "./alerts";
import astral from "./astral";
import auth from "./auth";
import calendar from "./calendar";
import common from "./common";
import intro from "./intro";
import landing from "./landing";
import network from "./network";
import reports from "./reports";
import settings from "./settings";
import units from "./units";
export default {
  addons: addons,
  airQuality: airQuality,
  alerts: alerts,
  astral: astral,
  auth: auth,
  calendar: calendar,
  common: common,
  landing: landing,
  network: network,
  reports: reports,
  settings: settings,
  units: units,
  intro: intro
};